import * as React from "react";
import { ThemeSize } from "../../../theme/_Types";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
/**
 * mttc implements mapThemeToClass for ModalThemeProps.
 *
 * @param theme the theme property of a themed Modal component.
 */
var mttc = function (theme) { return (joinClasses(theme && theme.size === ThemeSize.TINY ? "scl-m-modal--tiny" : undefined, theme && theme.size === ThemeSize.SMALL ? "scl-m-modal--small" : undefined, theme && theme.size === ThemeSize.HUGE ? "scl-m-modal--huge" : undefined)); };
/**
 *
 * @param props
 */
export var ModalComp = function (props) {
    var clazzName = joinClasses("scl-m-modal", props.className, !!props.inline ? "scl-m-modal--inline" : undefined);
    return (React.createElement("div", { id: props.modalID, className: joinClasses(clazzName, "scl-m-modal--active") },
        React.createElement("div", { className: "scl-m-modal__dialog" },
            React.createElement("div", { className: "scl-m-modal__content scl-h-shadow--huge" }, props.children))));
};
/**
 *
 */
export var Modal = asThemeConsumer(ModalComp, mttc);
